import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';

import { TtcMatInputModule } from '@libs/src/ttc-mat-input/ttc-mat-input.module';

import { HubConfigRolesBulkDeleteDrawerService } from './hub-config-roles-bulk-delete-drawer.service';

import { HubConfigRolesBulkDeleteDrawerComponent } from '@main-client/src/app/hub-configuration/hub-config-roles/hub-config-roles-bulk-delete-drawer/hub-config-roles-bulk-delete-drawer.component';

@NgModule({
  declarations: [HubConfigRolesBulkDeleteDrawerComponent],
  exports: [HubConfigRolesBulkDeleteDrawerComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatSlideToggleModule,
    NzDrawerModule,
    NzIconModule,
    NzTableModule,
    NzTabsModule,
    ReactiveFormsModule,
    TtcMatInputModule,
  ],
  providers: [HubConfigRolesBulkDeleteDrawerService],
})
export class HubConfigRolesBulkDeleteDrawerModule {}
